module.exports = __webpack_public_path__ + "./fonts/Obviously-Bold.ttf";